import { computed, inject, Injectable } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';

import { injectSuggestionsSetsService } from '@core/services/suggestions-sets/suggestions-sets.service';

import {
  SUGGESTION_CARDS_BLOCK_SUGGESTIONS_SET,
  SuggestionCardsBlockDataSource,
  SuggestionCardsBlockViewModel,
} from './suggestion-cards-block-view-model';

@Injectable()
export class SuggestionCardsBlockStoreDataSource implements SuggestionCardsBlockDataSource {
  private readonly suggestionsSet = inject(SUGGESTION_CARDS_BLOCK_SUGGESTIONS_SET);
  private readonly suggestionsResource = injectSuggestionsSetsService({
    suggestionSetId: this.suggestionsSet,
  }).productsToSuggestBySetQuery.selectSignal(this.suggestionsSet);

  private readonly vm = computed((): SuggestionCardsBlockViewModel => {
    const resource = this.suggestionsResource();
    return {
      suggestions: {
        hasValue: resource.hasValue,
        value: resource.value,
        isLoading: resource.isLoading,
      },
    };
  });

  readonly vm$ = toObservable(this.vm) as Observable<SuggestionCardsBlockViewModel>;
}
